<template>
  <div>
    <div style="height: 300px;"></div>
    <span>{{$t('user.login')}}</span>
    <input type="text" :placeholder="$t('user.loginUsername')" v-model="username" />

    <div @click="changeLanguage()">{{$t('language.name')}}</div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
          
      }
    },
    methods: {
      changeLanguage() {
        this.$i18n.locale == 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh' //设置中英文模式
        localStorage.setItem('languageSet', this.$i18n.locale) //将用户设置存储到localStorage以便用户下次打开时使用此设置
      },
      remind() {
        this.$toast(this.$t('user.loginUsername'))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index.vue